<div class="faq faq--{{faqType}}" [class.faq--opened]="faq.isOpened" *ngFor="let faq of faqListFormated; let i = index">
  <div class="faq__header" tabindex="0" (click)="toggleFaqIndex(i)" (keydown.space)="toggleFaqIndex(i)" (keydown.enter)="toggleFaqIndex(i)">
    <span class="faq__title">{{faq.question}}</span>
    <button *ngIf="isShowArrow" class="faq__arrow"></button>
  </div>
  <div class="faq__body" [@toggleItem]="faq.isOpened ? 'in' : 'out'">
    <article class="faq__content" [innerHtml]="faq.answerHtml">
    </article>
  </div>
</div>